'use client';
module.exports = require('../dist/components/Cluster/Cluster');
